import React from 'react';
import { Button } from '@chakra-ui/react';
import PropType from 'prop-types';

function SaveButton({ formId, dataAnalyticsId = undefined, isDisabled, ...props }) {
  return (
    <Button
      data-analytics-id={dataAnalyticsId}
      form={formId}
      isDisabled={isDisabled}
      type="submit"
      width="160px"
      {...props}
    >
      Save
    </Button>
  );
}

SaveButton.propTypes = {
  formId: PropType.string,
  dataAnalyticsId: PropType.string
};

export default SaveButton;
